// extracted by mini-css-extract-plugin
export default {"cls1":"JNbminwpbdlscAYbMcaR","cls2":"Fb4fEa4GAbqWhMs3JDDS JNbminwpbdlscAYbMcaR"};